import styled from "styled-components"
import TransitionFade from "../../../transition-fade"

const AddressTitle = styled.h3`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const StyledLink = styled(TransitionFade)`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`

export { AddressTitle, StyledLink }
